"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ValueSet_Expansion = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_ValueSet_Parameter_1 = require("./RTTI_ValueSet_Parameter");
var RTTI_ValueSet_Contains_1 = require("./RTTI_ValueSet_Contains");
exports.RTTI_ValueSet_Expansion = t.recursion('IValueSet_Expansion', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        identifier: RTTI_uri_1.RTTI_uri,
        _identifier: RTTI_Element_1.RTTI_Element,
        timestamp: RTTI_dateTime_1.RTTI_dateTime,
        _timestamp: RTTI_Element_1.RTTI_Element,
        total: RTTI_integer_1.RTTI_integer,
        _total: RTTI_Element_1.RTTI_Element,
        offset: RTTI_integer_1.RTTI_integer,
        _offset: RTTI_Element_1.RTTI_Element,
        parameter: t.array(RTTI_ValueSet_Parameter_1.RTTI_ValueSet_Parameter),
        contains: t.array(RTTI_ValueSet_Contains_1.RTTI_ValueSet_Contains)
    });
});
//# sourceMappingURL=RTTI_ValueSet_Expansion.js.map